import { array, boolean, object, ObjectSchema, string } from "yup";
import { ReviewStepFields, ReviewStepForm } from "./ReviewStep.types";
import { ErrorMessage } from "components/Form";

interface Props {
	nameRequired: boolean;
	contactRequired: boolean;
	descriptionRequired: boolean;
}

export const reviewStepFormSchema = ({
	nameRequired,
	contactRequired,
	descriptionRequired,
}: Props): ObjectSchema<ReviewStepForm> =>
	object({
		[ReviewStepFields.Name]: string().test(
			"requiredName",
			ErrorMessage.REQUIRED,
			value => !!value?.length || !nameRequired,
		),
		[ReviewStepFields.Contact]: string().test(
			"requiredContact",
			ErrorMessage.REQUIRED,
			value => !!value?.length || !contactRequired,
		),
		[ReviewStepFields.Fields]: array().of(
			object({
				[ReviewStepFields.Id]: string(),
				[ReviewStepFields.Label]: string(),
				[ReviewStepFields.Required]: boolean(),
				[ReviewStepFields.Value]: string().test(
					"requiredField",
					ErrorMessage.REQUIRED,
					(value, { parent }) => !!value?.length || !parent[ReviewStepFields.Required],
				),
			}),
		),
		[ReviewStepFields.Description]: string().test(
			"requiredDescription",
			ErrorMessage.REQUIRED,
			value => !!value?.length || !descriptionRequired,
		),
	});
